var styles = {"enterprise":"articleBodyNews-module_enterprise__cFAyQ","fadeout":"articleBodyNews-module_fadeout__qhx5G"};

export { styles as default };
//# sourceMappingURL=articleBodyNews.module.scss.esm.js.map
